<template>
  <!-- 音频 -->
  <div class="ctrl relative right-btn">
    <div class="btn-hover" @click.stop="startPlayOrPause">
      <i
        id="audioBtn"
        :class="
          loaded
            ? 'btns btns-audio0 inline-block'
            : 'btns btns-loading inline-block'
        "
      />

      <span class="absolute h-6 leading-none opacity-0 text-center tooltip-css">
        语音讲解
      </span>
    </div>
    <Player
      v-if="sources"
      style="display:none;"
      class="audio-bar"
      ref="audioRef"
      :loop="true"
      :sources="sources"
      :setting="[{ name: 'audioBar', value: true }]"
      :value="true"
      :data="briefAudio || detailAudio"
      :xhrWithCredentials="true"
      :loaded.sync="loaded"
    ></Player>
  </div>
</template>

<script>
import Player from '@/components/common/AudioPlayer'

export default {
  name: 'audio-bar',
  props: {
    showAudio: Boolean,
    data: null,
    briefAudio: null,
    detailAudio: null
  },
  components: {
    Player
  },
  watch: {
    showAudio(newVal) {
      this.change(newVal)
    },
    loaded(val) {
      if (!val) {
        return false
      }
      this.$nextTick(() => {
        // eslint-disable-next-line no-console
        console.log({
          ref: this.$refs.audioRef,
          playing: this.$refs.audioRef.playing
        })
        // this.$refs.audioRef.loop = true
        this.$refs.audioRef.togglePlayback()

        let audioBtn = document.getElementById('audioBtn')
        audioBtn.classList.remove('btns-audio0')
        audioBtn.classList.add('btns-audio-active')

        let timer = setTimeout(() => {
          // eslint-disable-next-line no-console
          console.log({
            ref: this.$refs.audioRef,
            playing: this.$refs.audioRef.playing
          })
          if (!this.$refs.audioRef || !this.$refs.audioRef.playing) {
            clearTimeout(timer)
            audioBtn.classList.remove('btns-audio-active')
            audioBtn.classList.add('btns-audio0')
          }
        }, 300)
      })

      // let i = 0
      // let audioBtn = document.getElementById('audioBtn')
      // let timer = setInterval(() => {
      //   // this.audioBtn = i
      //   audioBtn.classList.remove('btns-audio0')
      //   audioBtn.classList.remove('btns-audio1')
      //   audioBtn.classList.remove('btns-audio2')
      //   audioBtn.classList.add('btns-audio' + i)
      //   if (i === 2) {
      //     i = -1
      //   }
      //   i++
      //   if (!this.$refs.audioRef || !this.$refs.audioRef.playing) {
      //     clearInterval(timer)
      //     if (audioBtn) {
      //       audioBtn.classList.remove('btns-audio0')
      //       audioBtn.classList.remove('btns-audio1')
      //       audioBtn.classList.remove('btns-audio2')
      //       audioBtn.classList.add('btns-audio0')
      //     }
      //   }
      // }, 600)
    }
  },
  data() {
    return {
      sources: false,
      loaded: true
    }
  },
  mounted() {},
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause() {
      this.loaded = false
      this.sources = [
        (this.briefAudio && this.briefAudio.path_url) ||
          (this.detailAudio && this.detailAudio.path_url)
      ]
    }
  }
}
</script>
<style scoped lang="scss">
// 新
.audio-lists {
  top: 0;
  right: 82px;
  opacity: 0;
  > li {
    height: 34px;
    width: 220px;
    line-height: 32px;
    background-color: rgba(0, 0, 0, 0.7);
    margin-bottom: 3px;
  }
  &.active {
    transition: opacity 0.2s;
    -moz-transition: opacity 0.2s; /* Firefox 4 */
    -webkit-transition: opacity 0.2s; /* Safari 和 Chrome */
    -o-transition: opacity 0.2s; /* Opera */
    opacity: 1;
  }
}

.icon-close {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  top: 0rem;
  right: -1rem;
  font-size: 0.6rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  &:hover {
    color: #979797;
  }
}
</style>
